// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiCicContributor {
    'contribution': number;
    'profile': ApiProfileMin;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contribution",
            "baseName": "contribution",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "profile",
            "baseName": "profile",
            "type": "ApiProfileMin",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCicContributor.attributeTypeMap;
    }

    public constructor() {
    }
}
